import { render, staticRenderFns } from "./BlockSlideFormEpigraph.vue?vue&type=template&id=31af526a&"
import script from "./BlockSlideFormEpigraph.vue?vue&type=script&lang=js&"
export * from "./BlockSlideFormEpigraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports